import { __awaiter, __decorate, __generator, __metadata } from "tslib";
import { IconError, IconGreenCheck } from '@anex/common';
import { action, observable } from 'mobx';
import * as React from 'react';
import { pruneEmptyProps, toTitleCase } from '../services/helper';
export var AddressTypes;
(function (AddressTypes) {
    AddressTypes["Billing"] = "billing";
    AddressTypes["Delivery"] = "delivery";
})(AddressTypes || (AddressTypes = {}));
var DetailsStore = (function () {
    function DetailsStore(rootStore) {
        var _this = this;
        this.rootStore = rootStore;
        this.details = null;
        this.loading = false;
        this.existingAccount = false;
        this.accordCustomer = false;
        this.emailChanged = false;
        this.checkExistingAccount = function (emailAddress) { return __awaiter(_this, void 0, void 0, function () {
            var wholesaleCustomerCode, response, alert_1, alert_2, error_1, alert_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        wholesaleCustomerCode = this.rootStore.config.wholesaleCustomerCode;
                        return [4, this.rootStore.api.V1.Account.Check({
                                emailAddress: emailAddress,
                                wholesaleCustomerCode: this.rootStore.config
                                    .wholesaleCustomerCode,
                            })];
                    case 1:
                        response = _a.sent();
                        this.existingAccount = response.accountExists;
                        if (response.accountExists) {
                            alert_1 = {
                                dismissible: false,
                                message: "Looks like you're already an " + (wholesaleCustomerCode === 'OT'
                                    ? 'Accord'
                                    : wholesaleCustomerCode === 'ALDI'
                                        ? 'ALDI'
                                        : 'ANEX') + " customer. Enter your credentials below so that we can fast track you through the sign-up process.",
                                title: React.createElement(IconGreenCheck),
                                type: 'success',
                            };
                            this.rootStore.appStore.addAlert(alert_1);
                            this.rootStore.appStore.gotoState(1);
                            return [2];
                        }
                        else {
                            alert_2 = {
                                dismissible: false,
                                message: 'Email is not recognized, please try again.',
                                title: React.createElement(IconError),
                                type: 'danger',
                            };
                            this.rootStore.appStore.addAlert(alert_2);
                        }
                        return [3, 3];
                    case 2:
                        error_1 = _a.sent();
                        alert_3 = {
                            dismissible: true,
                            message: 'Something went wrong! Please try again.',
                            title: React.createElement(IconError),
                            type: 'danger',
                        };
                        this.rootStore.appStore.addAlert(alert_3);
                        return [3, 3];
                    case 3:
                        if (this.rootStore.appStore.currentStep === 3) {
                            this.emailChanged = false;
                            this.rootStore.appStore.nextStep();
                        }
                        return [2];
                }
            });
        }); };
        this.confirmIdentity = function (values) { return __awaiter(_this, void 0, void 0, function () {
            var request, response, details, error_2, alert_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        request = {
                            dateOfBirth: values.dateOfBirth,
                            emailAddress: values.emailAddress,
                            surname: values.lastName,
                            wholesaleCustomerCode: this.rootStore.config
                                .wholesaleCustomerCode,
                        };
                        return [4, this.rootStore.api.V1.Account.Verify.Index(request)];
                    case 1:
                        response = _a.sent();
                        details = this.mapPersonalDetailsFromVerificationResponse(response);
                        details.deliveryAddressRequired =
                            Object.getOwnPropertyNames(pruneEmptyProps(response.deliveryAddress)).length > 0;
                        details.deliveryAddressRequired =
                            Object.getOwnPropertyNames(pruneEmptyProps(response.deliveryAddress)).length > 0;
                        details.isBusiness = details.abn !== '';
                        this.details.formInitialValues = details;
                        this.rootStore.saleStore.accountCode = response.accountCode;
                        this.emailChanged = false;
                        this.rootStore.appStore.clearAlerts();
                        this.rootStore.appStore.gotoState(2);
                        return [3, 3];
                    case 2:
                        error_2 = _a.sent();
                        this.rootStore.appStore.clearAlerts();
                        alert_4 = {
                            dismissible: false,
                            message: 'Could not verify details. Please check your details and try again.',
                            title: React.createElement(IconError),
                            type: 'danger',
                        };
                        this.rootStore.appStore.addAlert(alert_4);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        }); };
        this.getInitialStoreState = function () { return ({
            formInitialValues: {
                abn: '',
                billingAddressLevelNumber: '',
                billingAddressLevelType: '',
                billingAddressPostcode: '',
                billingAddressRequired: false,
                billingAddressState: '',
                billingAddressStreetName: '',
                billingAddressStreetNumber: '',
                billingAddressStreetType: '',
                billingAddressSuburb: '',
                billingAddressUnitNumber: '',
                billingAddressUnitType: '',
                businessName: '',
                dateOfBirth: '',
                deliveryAddressLevelNumber: '',
                deliveryAddressLevelType: '',
                deliveryAddressPostcode: '',
                deliveryAddressRequired: false,
                deliveryAddressState: '',
                deliveryAddressStreetName: '',
                deliveryAddressStreetNumber: '',
                deliveryAddressStreetType: '',
                deliveryAddressSuburb: '',
                deliveryAddressUnitNumber: '',
                deliveryAddressUnitType: '',
                emailAddress: '',
                firstName: '',
                isBusiness: false,
                lastName: '',
                phoneNumber: '',
                phoneType: 'mobile',
                title: '',
            },
            formValues: null,
        }); };
        this.details = this.getInitialStoreState();
    }
    DetailsStore.prototype.setDetailsFromForm = function (details) {
        this.details.formValues = details;
    };
    DetailsStore.prototype.reset = function () {
        this.details = this.getInitialStoreState();
        this.existingAccount = false;
        this.rootStore.saleStore.accountCode = '';
    };
    DetailsStore.prototype.mapPersonalDetailsFromVerificationResponse = function (response) {
        return {
            abn: response.details.abn || '',
            billingAddressLevelNumber: response.billingAddress.levelNumber || '',
            billingAddressLevelType: response.billingAddress.levelType || '',
            billingAddressPostcode: response.billingAddress.postCode || '',
            billingAddressState: response.billingAddress.state || '',
            billingAddressStreetName: response.billingAddress.streetName || '',
            billingAddressStreetNumber: response.billingAddress.streetNumber || '',
            billingAddressStreetType: toTitleCase(response.billingAddress.streetType) || '',
            billingAddressSuburb: response.billingAddress.suburb || '',
            billingAddressUnitNumber: response.billingAddress.unitNumber || '',
            billingAddressUnitType: response.billingAddress.unitType || '',
            businessName: response.details.businessName || '',
            checkAddressStore: '',
            dateOfBirth: response.details.dateOfBirth || '',
            deliveryAddressLevelNumber: response.deliveryAddress.levelNumber || '',
            deliveryAddressLevelType: response.deliveryAddress.levelType || '',
            deliveryAddressPostcode: response.deliveryAddress.postCode || '',
            deliveryAddressState: response.deliveryAddress.state || '',
            deliveryAddressStreetName: response.deliveryAddress.streetName || '',
            deliveryAddressStreetNumber: response.deliveryAddress.streetNumber || '',
            deliveryAddressStreetType: toTitleCase(response.deliveryAddress.streetType) || '',
            deliveryAddressSuburb: response.deliveryAddress.suburb || '',
            deliveryAddressUnitNumber: response.deliveryAddress.unitNumber || '',
            deliveryAddressUnitType: response.deliveryAddress.unitType || '',
            emailAddress: response.details.emailAddress || '',
            firstName: response.details.firstName || '',
            lastName: response.details.lastName || '',
            phoneNumber: response.details.phoneNumber || '',
            phoneType: response.details.phoneNumberType || '',
            title: response.details.title || '',
        };
    };
    __decorate([
        observable,
        __metadata("design:type", Object)
    ], DetailsStore.prototype, "details", void 0);
    __decorate([
        observable,
        __metadata("design:type", Boolean)
    ], DetailsStore.prototype, "loading", void 0);
    __decorate([
        observable,
        __metadata("design:type", Boolean)
    ], DetailsStore.prototype, "existingAccount", void 0);
    __decorate([
        observable,
        __metadata("design:type", Boolean)
    ], DetailsStore.prototype, "accordCustomer", void 0);
    __decorate([
        observable,
        __metadata("design:type", Boolean)
    ], DetailsStore.prototype, "emailChanged", void 0);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DetailsStore.prototype, "setDetailsFromForm", null);
    __decorate([
        action,
        __metadata("design:type", Object)
    ], DetailsStore.prototype, "checkExistingAccount", void 0);
    __decorate([
        action,
        __metadata("design:type", Object)
    ], DetailsStore.prototype, "confirmIdentity", void 0);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], DetailsStore.prototype, "reset", null);
    return DetailsStore;
}());
export { DetailsStore };
//# sourceMappingURL=DetailsStore.js.map